import gql from 'graphql-tag';

export const SpaceRestrictionCheckQueryExperimental = gql`
	query SpaceRestrictionCheckQueryExperimental($spaceKey: String!) @experimental {
		experimentalSpace(spaceKey: $spaceKey) {
			statusCode
		}
	}
`;
